export default{
    get(url,data={}){
        return $.ajax({
            url: "/sibh/api/v1/"+url,
            type:"GET",
            data: data,
            headers: {'User-Email': cookies.user_email, 'User-Token': cookies.user_token},
            success: function(data){
                return data
            }
        })
    },
    post(url, data={}){
        return $.ajax({
            url: "/sibh/api/v1/"+url,
            type:"POST",
            data: data,
            headers: {'User-Email': cookies.user_email, 'User-Token': cookies.user_token},
            success: function(data){
                return data
            }
        })
    },
    request(url, type, data){
        return $.ajax({
            url: "/sibh/api/v1/"+url,
            type:type,
            data: data,
            headers: {'User-Email': cookies.user_email, 'User-Token': cookies.user_token},
            success: function(data){
                return data
            }
        })
    }
}